const ChevronDown = (props) => {
  return (
    <svg width="22" height="12" viewBox="0 0 23 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.99999 3.68178L7.11112 0.5L8 1.40908L3.99999 5.5L0 1.40908L0.888891 0.5L3.99999 3.68178Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default ChevronDown;
